module.exports = __webpack_public_path__ + "whyProfistopIco.png?bd932c1b4fe976e5663d0d595c9f9204";